module.exports = __webpack_public_path__ + "media/images/social-share-button/vkontakte-95d12226592d908e557f61bd5e67c5ec.svg";